module.exports = __webpack_public_path__ + "img/mini.c21aa3cd.png";